import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

/** Indicative delivery charges (catalog banner modal). */
const DELIVERY_CHARGES_TABLE_ROWS = [
  {
    band: "Below ₹50,000",
    chennai: 1500,
    bengaluru: 3300,
    hyderabad: 6300,
  },
  {
    band: "Above ₹50,000",
    chennai: "FREE",
    bengaluru: "FREE",
    hyderabad: "FREE",
  },
  {
    band: "Sample Order",
    chennai: "FREE",
    bengaluru: "FREE",
    hyderabad: "FREE",
    highlight: true,
  },
];

function deliveryChargeCellDisplay(value) {
  if (value === "FREE") {
    return <span className="fw-bold text-success">FREE</span>;
  }
  return `₹${value.toLocaleString("en-IN")}`;
}

/**
 * Light banner + “View Charges” modal with the indicative delivery table.
 * @param {{
 *   className?: string,
 *   modalOpen?: boolean,
 *   onModalOpenChange?: (open: boolean) => void,
 * }} props — optional wrapper classes (e.g. `px-3 mt-3` or `mb-2`)
 */
export default function StoreDeliveryChargesInfo({
  className,
  modalOpen: controlledModalOpen,
  onModalOpenChange,
}) {
  const [internalModalOpen, setInternalModalOpen] = useState(false);
  const modalOpen = controlledModalOpen ?? internalModalOpen;
  const setModalOpen = onModalOpenChange ?? setInternalModalOpen;
  const showBanner = !String(className ?? "").includes("d-none");

  return (
    <>
      {showBanner ? (
        <div className={className}>
          <button
            type="button"
            className="rounded-3 p-2 d-flex flex-wrap align-items-center justify-content-between gap-2 border w-100 text-start"
            style={{
              background: "#FDEA9F",
              borderColor: "#fdea9f",
              cursor: "pointer",
              font: "inherit",
              color: "inherit",
            }}
            onClick={() => setModalOpen(true)}
          >
            <span className="text-dark small" style={{ letterSpacing: "0.01em" }}>
              <b>FREE DELIVERY</b> for orders <b>above ₹50,000</b> -{" "}
              <span className="fw-bold text-primary text-nowrap">
                View Charges
              </span>
            </span>
          </button>
        </div>
      ) : null}

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Delivery Charges
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table table-sm table-bordered align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th scope="col">Order value</th>
                  <th scope="col" className="text-end">
                    Chennai
                  </th>
                  <th scope="col" className="text-end">
                    Bengaluru
                  </th>
                  <th scope="col" className="text-end">
                    Hyderabad
                  </th>
                </tr>
              </thead>
              <tbody className="small">
                {DELIVERY_CHARGES_TABLE_ROWS.map((row) => {
                  const highlightCellClass = row.highlight
                    ? "bg-success-subtle"
                    : "";
                  return (
                    <tr key={row.band}>
                      <th
                        scope="row"
                        className={`fw-semibold ${highlightCellClass}`.trim()}
                      >
                        {row.band}
                      </th>
                      <td
                        className={`text-end text-nowrap ${highlightCellClass}`.trim()}
                      >
                        {deliveryChargeCellDisplay(row.chennai)}
                      </td>
                      <td
                        className={`text-end text-nowrap ${highlightCellClass}`.trim()}
                      >
                        {deliveryChargeCellDisplay(row.bengaluru)}
                      </td>
                      <td
                        className={`text-end text-nowrap ${highlightCellClass}`.trim()}
                      >
                        {deliveryChargeCellDisplay(row.hyderabad)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="text-secondary small mt-3 mb-0">
            Other Cities: Less than 350 km: ₹3,300. Greater than 350 km: ₹6,300.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
